import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICountStats } from '@models';

import { Observable } from 'rxjs';

@Injectable()
export class StatsService {
    public sessions$!: Observable<ICountStats[]>;
    public jobs$!: Observable<ICountStats[]>;

    private _endpoint = '/api/stats';

    constructor(private _http: HttpClient) {
    }

    public getCountStats() {
        return this._http.get<Array<ICountStats>>(`${this._endpoint}/GetCountStats`);
    }

    public getSessionsStats = () => {
        return this._http.get<any>(`${this._endpoint}/GetSessionsStats`);
    }

    public getJobsStats = () => {
        return this._http.get<any>(`${this._endpoint}/GetJobsStats`);
    }
}
